<template>
  <LandingDesktop v-if="$tvaMq !== 'mobile' && $tvaMq !== 'tablet'" />
  <LandingMobile v-else />
</template>

<script>
import LandingMobile from "./LandingMobile.vue";
import LandingDesktop from "./LandingDesktop.vue";
import { mapActions } from "vuex";

export default {
  name: "Landing",
  components: {
    LandingMobile,
    LandingDesktop,
  },
  data() {
    return {
      link: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.setLink(from);
      // vm.link = from;
      vm.show = true;
    });
    next();
  },
  methods: {
    ...mapActions({
      setLink: "ui/setPreviousLink",
    }),
  },
};
</script>

<style lang="scss" scoped></style>
